import { Component, HostListener, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ApiUrlHelper } from 'src/app/common/apiUrlHelper';
import { CommonConstant } from 'src/app/constants/common-constant';
import { UserModel } from 'src/app/models/user-model';
import { CommonService } from 'src/app/services/common/common.service';
import { DirtycheckDialogboxComponent } from '../../dirtycheck-dialogbox/dirtycheck-dialogbox.component';
import { UserConstant } from 'src/app/constants/label-constants';
import { ReplaySubject, Subject, takeUntil } from 'rxjs';
import { MatSelect } from '@angular/material/select';
import { commonErrorMessage } from 'src/app/constants/error-message-constant';
interface AdminRole {
  adminRoleId: any;
  adminRoleName: string;
}
@Component({
  selector: 'app-user-add-edit',
  templateUrl: './user-add-edit.component.html',
  styleUrls: ['./user-add-edit.component.scss']
})
export class UserAddEditComponent {
  UserForm: FormGroup = this.formBuilder.group({});
  AdminRoleList: any = [];
  userId: number = 0;
  commonConstant: any = [];
  commonErrorMessage: any = [];
  UserConstant: any = [];
  protected AllAdminlist: AdminRole[] = this.AdminRoleList;
  public Ctrl: FormControl = new FormControl();
  public FilterCtrl: FormControl = new FormControl();
  public filteredAdminData: ReplaySubject<any> = new ReplaySubject();
  flag: boolean = false;
  @HostListener('window:beforeunload', ['$event'])
  public canDeactivate(event: BeforeUnloadEvent): void {
    if (this.UserForm.dirty) {
      event.preventDefault();
      event.returnValue = false;
    }
  }
  @ViewChild('singleSelect', { static: true })
  singleSelect!: MatSelect;

  protected _onDestroy = new Subject();
  ngOnDestroy() {
    this._onDestroy.next(1);
    this._onDestroy.complete();
  }

  protected filterAdmin() {
    if (!this.AllAdminlist) {
      return;
    }
    let search = this.FilterCtrl.value;
    if (!search) {
      this.filteredAdminData.next(this.AllAdminlist.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredAdminData.next(
      this.AllAdminlist.filter(data => data.adminRoleName.toLowerCase().indexOf(search) > -1)
    );
  }

  constructor(
    private CommonService: CommonService,
    private formBuilder: FormBuilder,
    private toastr: ToastrService,
    private apiUrl: ApiUrlHelper,
    private spinner: NgxSpinnerService,
    public modalService: NgbActiveModal,
    public ModalService: NgbModal,
  ) { }

  ngOnInit(): void {
    this.Ctrl.setValue(this.AllAdminlist[1]);
    this.filteredAdminData.next(this.AllAdminlist.slice());
    this.FilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterAdmin();
      });
    this.spinner.show();
    this.UserConstant = UserConstant;
    this.commonConstant = CommonConstant;
    this.commonErrorMessage = commonErrorMessage;
    this.onInitUserForm();
    if (this.userId > 0) {
      this.getUserDetail(this.userId);
    }
    else {
      this.userId = 0;
    }
    this.getAdminRoleList();
  }

  onInitUserForm() {
    this.UserForm = this.formBuilder.group({
      userId: [0],
      FirstName: ['', [Validators.required, Validators.maxLength(100)]],
      LastName: ['', [Validators.required, Validators.maxLength(100)]],
      EmailId: ['', [Validators.required, Validators.maxLength(100), Validators.pattern(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]],
      MobileNo: ['', [Validators.required, Validators.pattern(/^[6-9][0-9]{9}$/)]],
      adminRoleId: ['', [Validators.required]]
    });
  }

  get userFormControl() {
    return this.UserForm.controls;
  }

  onCancel() {
    if (this.UserForm.dirty) {
      const modalRef = this.ModalService.open(DirtycheckDialogboxComponent, { centered: true, backdrop: 'static', keyboard: false });
      modalRef.componentInstance.UserForm = this.UserForm;
    }
    else {
      this.modalService.close();
    }
  }

  getUserDetail(userId: number) {
    this.spinner.show();
    const apiUrl = this.apiUrl.apiUrl.user.GetUserById.replace("{id}", userId.toString());
    this.CommonService.doGet(apiUrl).pipe().subscribe({
      next: (data) => {
        this.spinner.hide();
        this.setUserForm(data.data[0]);
      },
      error: (err) => {
        this.spinner.hide();
        console.log('getGetUserById-Error', err);
      }
    });
  }

  setUserForm(data) {
    this.UserForm.setValue({
      userId: (data.userId) ? data.userId : 0,
      FirstName: data.firstName != '' ? data.firstName : '',
      LastName: data.lastName != '' ? data.lastName : '',
      EmailId: data.emailId.toLowerCase(),
      MobileNo: data.mobileNo,
      adminRoleId: data.adminRoleId,
    });
  }

  getAdminRoleList() {
    const apiUrl = this.apiUrl.apiUrl.user.AdminRoleList;
    this.CommonService.doGet(apiUrl).pipe().subscribe({
      next: (data) => {
        if (data && data.data && data.data.length > 0) {
          this.AdminRoleList = data.data.filter(d => d.adminRoleId && d.adminRoleName);
          this.spinner.hide()
          this.flag = true;
        }
        this.AllAdminlist = this.AdminRoleList;
        this.filterAdmin();
      },
      error: (err) => {
        console.log('getRoleList-Error', err);
      }
    });
  }

  keyPressNumbers(event) {
    var charCode = (event.which) ? event.which : event.keyCode;
    if ((charCode < 48 || charCode > 57)) {
      event.preventDefault();
      return false;
    } else {
      return true;
    }
  }

  saveUser() {
    if (!this.UserForm.valid) {
      return;
    }
    this.spinner.show();
    const objData: UserModel = {
      UserId: !this.UserForm.value.userId ? 0 : this.UserForm.value.userId,
      FirstName: this.UserForm.value.FirstName.trim(),
      LastName: this.UserForm.value.LastName.trim(),
      EmailId: this.UserForm.value.EmailId.toLowerCase().trim(),
      MobileNo: this.UserForm.value.MobileNo.trim(),
      adminRoleId: this.UserForm.value.adminRoleId,
    }
    const apiUrl = this.apiUrl.apiUrl.user.SaveUser;
    this.CommonService.doPost(apiUrl, objData).pipe().subscribe({
      next: (data) => {
        if (data.success) {
          this.modalService.close('save');
          this.toastr.success(data.message);
          this.spinner.hide();
        }
        else {
          this.spinner.hide();
          this.toastr.error(data.message);
        }
      },
      error: (er) => {
        console.error(er)
      }
    });
  }
}
